import { Component } from 'react';
import { string } from 'prop-types';

import { LOGIN_PATH } from '../../../auth';

class ShibbolethLogin extends Component {
  componentDidMount() {
    const { referrer } = this.props;
    const encodedReferrerURI = encodeURI(referrer);

    window.location.href = `${LOGIN_PATH}?referrer=${encodedReferrerURI}`;
  }

  render() {
    return null;
  }
}

ShibbolethLogin.propTypes = {
  referrer: string.isRequired
};

export { ShibbolethLogin as UnwrappedShibbolethLogin };

export default ShibbolethLogin;
